"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableWidget = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("./components");
require("./types");
const WidgetSpinner_1 = require("./WidgetSpinner");
const TableWidget = ({ isLoading, rows, isShrink }) => {
    return isLoading ? (react_1.default.createElement(WidgetSpinner_1.WidgetSpinner, null)) : (react_1.default.createElement(components_1.WDiv, null,
        react_1.default.createElement(components_1.WTable, { isShrink: isShrink },
            react_1.default.createElement("tbody", null, rows.map((item, idx) => {
                const borderTop = idx !== 0 ? '1px solid #C0C0C0' : '';
                const paddingTop = idx !== 0 ? '1px' : '';
                return (react_1.default.createElement(components_1.WTr, { key: item.id, borderTop: borderTop, paddingTop: paddingTop, onClick: item.onClick }, item.content));
            })))));
};
exports.TableWidget = TableWidget;
//# sourceMappingURL=TableWidget.js.map